import {
  SET_BUSINESS_DAY_SETTINGS_DATA_LOADING,
  SET_BUSINESS_DAY_SETTINGS_DATA,
} from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const findBusinessDaySettings = (branchId) => async (dispatch) => {
  try {
    dispatch({ type: SET_BUSINESS_DAY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    if (!companyId || !branchId) {
      dispatch({ type: SET_BUSINESS_DAY_SETTINGS_DATA_LOADING, payload: false });
      return false;
    }

    const res = await Axios.get(
      '/api/dashboard/settings/find-business-day-settings-for-branch',
      {
        params: { companyId, branchId },
      }
    );
    dispatch({
      type: SET_BUSINESS_DAY_SETTINGS_DATA,
      payload: res.data.data,
    });

    return true;
  } catch (error) {
    // Do not wipe settings to [] — that looks like feature-off defaults.
    dispatch({ type: SET_BUSINESS_DAY_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};

export const updateBusinessDaySettings = (businessDaySettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_BUSINESS_DAY_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const requestBody = {
      ...businessDaySettings.businessDaySettingsData,
    };

    const queryParams = {
      companyId,
      branchId: businessDaySettings.branchId,
    };

    await Axios.post(
      '/api/dashboard/settings/update-business-day-settings',
      requestBody,
      { params: queryParams }
    );
    dispatch({ type: SET_BUSINESS_DAY_SETTINGS_DATA_LOADING, payload: false });
    return { success: true };
  } catch (err) {
    dispatch({ type: SET_BUSINESS_DAY_SETTINGS_DATA_LOADING, payload: false });
    const message =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      'Failed to update Business Day settings';
    return { success: false, message };
  }
};
